<template>
  <b-container style="">
    <div style="display: flex">
      <b-breadcrumb :items="items" style="margin-top: 16px"></b-breadcrumb>
    </div>

    <b-row style="padding-top: 8px">
      <b-col md="4">
        <div v-if="!loaded" class="text-center">
          <b-spinner />
        </div>

        <div v-if="this.errorMessage" style="color: red">
          {{ this.errorMessage }} 
          <div>
            Server uses reservation date of tomorrow, so room is not available...
          </div>
        </div>

        <b-list-group
          style="overflow: auto; max-height: 1000px; margin-bottom: 16px"
        >
          <b-list-group-item
            v-for="offer in this.offers"
            :key="offer.id"
            button
            @click="handleSelect(offer)"
            :active="selectedOffer.id == offer.id"
            style="text-align: left"
          >
            {{
              `${offer.rateCode} ${offer.price.total} ${offer.price.currency} ${offer.room.type}`
            }}
          </b-list-group-item>
        </b-list-group>
      </b-col>

      <b-col v-if="this.selectedOffer.id" style="overflow: auto">
        <div>
          <b-form-group>
            <label style="padding-bottom: 4px">Rate Code</label>
            <b-form-input
              placeholder="Rate Code"
              v-model="selectedOffer.rateCode"
              disabled
            />
          </b-form-group>

          <b-form-group>
            <label style="padding-bottom: 4px">Room Type</label>
            <b-form-input v-model="selectedOffer.room.type" disabled />
          </b-form-group>

          <b-form-group v-if="this.selectedOffer.room.typeEstimated">
            <label style="padding-bottom: 4px">Category</label>
            <b-form-input
              v-model="selectedOffer.room.typeEstimated.category"
              disabled
            />
          </b-form-group>

          <b-form-group v-if="this.selectedOffer.room.typeEstimated">
            <label style="padding-bottom: 4px">Beds</label>
            <b-form-input
              v-model="selectedOffer.room.typeEstimated.beds"
              disabled
            />
          </b-form-group>

          <b-form-group v-if="this.selectedOffer.room.typeEstimated">
            <label style="padding-bottom: 4px">Bed Type</label>
            <b-form-input
              v-model="selectedOffer.room.typeEstimated.bedType"
              disabled
            />
          </b-form-group>

          <b-form-group>
            <label style="padding-bottom: 4px">Description</label>
            <b-form-textarea
              v-model="selectedOffer.room.description.text"
              disabled
              style="height: 150px"
            />
          </b-form-group>

          <b-form-group>
            <label style="padding-bottom: 4px">Policies</label>
            <b-form-textarea
              v-model="selectedOffer.policies"
              disabled
              style="height: 200px"
            />
          </b-form-group>

          <div style="margin-top: 12px">
            <b-button
              v-if="selectedOffer.id"
              variant="outline-primary"
              :to="`/offer/${selectedOffer.id}`"
            >
              Offer Details</b-button
            >

            <b-button
              variant="light"
              v-if="this.selectedOffer.id"
              @click="selectedOffer = {}"
            >
              Cancel
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      offers: [],
      selectedOffer: {},
      loaded: false,
      items: [
        {
          text: "Hotels",
          href: "#/"
        },
        {
          text: `${this.$route.params.id}`
        }
      ],
      errorMessage: null
    };
  },
  mounted() {
    this.fetchOffers();
  },
  methods: {
    async fetchOffers() {
      const hotelId = this.$route.params.id;
      const response = await fetch(`/hotel/details_json?hotelId=${hotelId}`);

      this.loaded = true;

      const json = await response.json();

      console.log(json);

      if (!json.data) {
        console.log(json.result.errors[0].title);
        this.errorMessage = json.result.errors[0].title;
        // this.errorMessage = "Offers unavailable"
        return;
      }

      if (json.data) {
        const data = json.data;
        this.offers = json.data.offers;
        console.log(json.result);

        this.items = [
          {
            text: "Hotels",
            href: "#/"
          },
          {
            text: `${data.hotel.name}`
          }
        ];
      }
    },
    handleSelect(offer) {
      this.selectedOffer = offer;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Offers.vue